import {
	IBusTuyenDuongSelectChuaPhanTuyenRequest,
	IBusTuyenDuongUpdatePhanTuyenHocSinhRequest
} from "../../../api/bus/busTuyenDuongApi";
import { IBusTuyenDuongChiTietSelectRequest } from "../../../api/bus/busTuyenDuongChiTietApi";
import { IBusTuyenDuongSelectRequest } from "../../../models/request/bus/busBaoCaoDiemDanhRequest";
import { IUploadExcelTuyenDuongChiTietRequest } from "../../../models/request/bus/uploadExcelRequest";
import { BusHocSinhChuaPhanTuyenResponse } from "../../../models/response/bus/bus_dangkyxe";
import { BusDiemDonTraItemResponse } from "../../../models/response/bus/bus_diemdontra";
import { bus_loaidiemdon } from "../../../models/response/bus/bus_loaidiemdon";
import { bus_tuyenduong_chitiet, BusTuyenDuongChiTietItemResponse } from "../../../models/response/bus/bus_tuyenduong_chitiet";
import { BusPhanTuyenItemResponse } from "../../../models/response/bus/BusPhanTuyenItemResponse";
import {
	eBusPhanTuyenActionTypeIds,
	IBusPhanTuyenAddHocSinhRequest,
	IBusPhanTuyenChangeHocSinhChuaPhanTuyenSelectedIds,
	IBusPhanTuyenCloseAddHocSinhModal,
	IBusPhanTuyenCloseDeleteHocSinhConfirm,
	IBusPhanTuyenCloseDeleteTuyenDuongChiTietConfirm,
	IBusPhanTuyenCloseImportChiTietModal,
	IBusPhanTuyenCloseTuyenDuongChiTietDetail,
	IBusPhanTuyenDeleteHocSinhErr,
	IBusPhanTuyenDeleteHocSinhStart,
	IBusPhanTuyenDeleteHocSinhSuccess,
	IBusPhanTuyenDeleteTuyenDuongChiTietErr,
	IBusPhanTuyenDeleteTuyenDuongChiTietStart,
	IBusPhanTuyenDeleteTuyenDuongChiTietSuccess,
	IBusPhanTuyenHuyDangKyRequest,
	IBusPhanTuyenImportChiTietErr,
	IBusPhanTuyenImportChiTietStart,
	IBusPhanTuyenImportChiTietSuccess,
	IBusPhanTuyenLoadDiemDonTraErr,
	IBusPhanTuyenLoadDiemDonTraStart,
	IBusPhanTuyenLoadDiemDonTraSuccess,
	IBusPhanTuyenLoadErr,
	IBusPhanTuyenLoadHocSinhChuaPhanTuyenErr,
	IBusPhanTuyenLoadHocSinhChuaPhanTuyenStart,
	IBusPhanTuyenLoadHocSinhChuaPhanTuyenSuccess,
	IBusPhanTuyenLoadLoaiDiemDonErr,
	IBusPhanTuyenLoadLoaiDiemDonStart,
	IBusPhanTuyenLoadLoaiDiemDonSuccess,
	IBusPhanTuyenLoadStart,
	IBusPhanTuyenLoadSuccess,
	IBusPhanTuyenLoadTuyenDuongChiTietErr,
	IBusPhanTuyenLoadTuyenDuongChiTietStart,
	IBusPhanTuyenLoadTuyenDuongChiTietSuccess,
	IBusPhanTuyenSavePhanTuyenHocSinhErr,
	IBusPhanTuyenSavePhanTuyenHocSinhStart,
	IBusPhanTuyenSavePhanTuyenHocSinhSuccess,
	IBusPhanTuyenSaveTuyenDuongChiTietErr,
	IBusPhanTuyenSaveTuyenDuongChiTietStart,
	IBusPhanTuyenSaveTuyenDuongChiTietSuccess,
	IBusPhanTuyenShowAddHocSinhModal,
	IBusPhanTuyenShowDeleteHocSinhConfirm,
	IBusPhanTuyenShowDeleteTuyenDuongChiTietConfirm,
	IBusPhanTuyenShowImportChiTietModal,
	IBusPhanTuyenShowTuyenDuongChiTietDetail,
	IBusPhanTuyenValidateImportChiTietErr,
	IBusPhanTuyenValidateImportChiTietStart,
	IBusPhanTuyenValidateImportChiTietSuccess
} from "../../action-types/bus/IBusPhanTuyenActionTypes";

export const busPhanTuyenActions = {
	loadBusPhanTuyenStart: (request: IBusTuyenDuongSelectRequest): IBusPhanTuyenLoadStart => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_START,
			payload: request
		}
	},
	loadBusPhanTuyenSuccess: (data: BusPhanTuyenItemResponse[]): IBusPhanTuyenLoadSuccess => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadBusPhanTuyenError: (message: string): IBusPhanTuyenLoadErr => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadBusTuyenDuongChiTietStart: (request: IBusTuyenDuongChiTietSelectRequest): IBusPhanTuyenLoadTuyenDuongChiTietStart => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_TUYENDUONG_CHITIET_START,
			payload: request
		}
	},
	loadBusTuyenDuongChiTietSuccess: (data: BusTuyenDuongChiTietItemResponse[]): IBusPhanTuyenLoadTuyenDuongChiTietSuccess => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_TUYENDUONG_CHITIET_SUCCESS,
			payload: data
		}
	},
	loadBusTuyenDuongChiTietError: (message: string): IBusPhanTuyenLoadTuyenDuongChiTietErr => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_TUYENDUONG_CHITIET_ERROR,
			payload: message
		}
	},
	loadBusDiemDonTraStart: (dm_coso_id: number): IBusPhanTuyenLoadDiemDonTraStart => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_DIEMDONTRA_START,
			payload: dm_coso_id
		}
	},
	loadBusDiemDonTraSuccess: (data: BusDiemDonTraItemResponse[]): IBusPhanTuyenLoadDiemDonTraSuccess => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_DIEMDONTRA_SUCCESS,
			payload: data
		}
	},
	loadBusDiemDonTraError: (message: string): IBusPhanTuyenLoadDiemDonTraErr => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_DIEMDONTRA_ERROR,
			payload: message
		}
	},
	loadBusLoaiDiemDonStart: (): IBusPhanTuyenLoadLoaiDiemDonStart => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_LOAIDIEMDON_START
		}
	},
	loadBusLoaiDiemDonSuccess: (data: bus_loaidiemdon[]): IBusPhanTuyenLoadLoaiDiemDonSuccess => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_LOAIDIEMDON_SUCCESS,
			payload: data
		}
	},
	loadBusLoaiDiemDonError: (message: string): IBusPhanTuyenLoadLoaiDiemDonErr => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_LOAIDIEMDON_ERROR,
			payload: message
		}
	},
	showBusTuyenDuongChiTietDetail: (data: BusTuyenDuongChiTietItemResponse): IBusPhanTuyenShowTuyenDuongChiTietDetail => {
		return {
			type: eBusPhanTuyenActionTypeIds.SHOW_TUYENDUONG_CHITIET_DETAIL,
			payload: data
		}
	},
	closeBusTuyenDuongChiTietDetail: (): IBusPhanTuyenCloseTuyenDuongChiTietDetail => {
		return {
			type: eBusPhanTuyenActionTypeIds.CLOSE_TUYENDUONG_CHITIET_DETAIL
		}
	},
	saveBusTuyenDuongChiTietStart: (data: bus_tuyenduong_chitiet): IBusPhanTuyenSaveTuyenDuongChiTietStart => {
		return {
			type: eBusPhanTuyenActionTypeIds.SAVE_TUYENDUONG_CHITIET_START,
			payload: data
		}
	},
	saveBusTuyenDuongChiTietSuccess: (is_update: boolean): IBusPhanTuyenSaveTuyenDuongChiTietSuccess => {
		return {
			type: eBusPhanTuyenActionTypeIds.SAVE_TUYENDUONG_CHITIET_SUCCESS,
			payload: is_update
		}
	},
	saveBusTuyenDuongChiTietError: (message: string): IBusPhanTuyenSaveTuyenDuongChiTietErr => {
		return {
			type: eBusPhanTuyenActionTypeIds.SAVE_TUYENDUONG_CHITIET_ERROR,
			payload: message
		}
	},
	showDeleteBusTuyenDuongChiTietConfirm: (data: BusTuyenDuongChiTietItemResponse): IBusPhanTuyenShowDeleteTuyenDuongChiTietConfirm => {
		return {
			type: eBusPhanTuyenActionTypeIds.SHOW_DELETE_TUYENDUONG_CHITIET_CONFIRM,
			payload: data
		}
	},
	closeDeleteBusTuyenDuongChiTietConfirm: (): IBusPhanTuyenCloseDeleteTuyenDuongChiTietConfirm => {
		return {
			type: eBusPhanTuyenActionTypeIds.CLOSE_DELETE_TUYENDUONG_CHITIET_CONFIRM
		}
	},
	deleteBusTuyenDuongChiTietStart: (id: number): IBusPhanTuyenDeleteTuyenDuongChiTietStart => {
		return {
			type: eBusPhanTuyenActionTypeIds.DELETE_TUYENDUONG_CHITIET_START,
			payload: id
		}
	},
	deleteBusTuyenDuongChiTietSuccess: (): IBusPhanTuyenDeleteTuyenDuongChiTietSuccess => {
		return {
			type: eBusPhanTuyenActionTypeIds.DELETE_TUYENDUONG_CHITIET_SUCCESS
		}
	},
	deleteBusTuyenDuongChiTietError: (message: string): IBusPhanTuyenDeleteTuyenDuongChiTietErr => {
		return {
			type: eBusPhanTuyenActionTypeIds.DELETE_TUYENDUONG_CHITIET_ERROR,
			payload: message
		}
	},
	showAddHocSinhModal: (request: IBusPhanTuyenAddHocSinhRequest): IBusPhanTuyenShowAddHocSinhModal => {
		return {
			type: eBusPhanTuyenActionTypeIds.SHOW_ADD_HOCSINH_MODAL,
			payload: request
		}
	},
	closeAddHocSinhModal: (): IBusPhanTuyenCloseAddHocSinhModal => {
		return {
			type: eBusPhanTuyenActionTypeIds.CLOSE_ADD_HOCSINH_MODAL
		}
	},
	loadHocSinhChuaPhanTuyenStart: (request: IBusTuyenDuongSelectChuaPhanTuyenRequest): IBusPhanTuyenLoadHocSinhChuaPhanTuyenStart => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_HOCSINH_CHUAPHANTUYEN_START,
			payload: request
		}
	},
	loadHocSinhChuaPhanTuyenSuccess: (data: BusHocSinhChuaPhanTuyenResponse[]): IBusPhanTuyenLoadHocSinhChuaPhanTuyenSuccess => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_HOCSINH_CHUAPHANTUYEN_SUCCESS,
			payload: data
		}
	},
	loadHocSinhChuaPhanTuyenError: (message: string): IBusPhanTuyenLoadHocSinhChuaPhanTuyenErr => {
		return {
			type: eBusPhanTuyenActionTypeIds.LOAD_HOCSINH_CHUAPHANTUYEN_ERROR,
			payload: message
		}
	},
	changeHocSinhChuaPhanTuyenSelectedIds: (ids: number[]): IBusPhanTuyenChangeHocSinhChuaPhanTuyenSelectedIds => {
		return {
			type: eBusPhanTuyenActionTypeIds.CHANGE_HOCSINH_CHUAPHANTUYEN_SELECTED_IDS,
			payload: ids
		}
	},
	savePhanTuyenHocSinhStart: (request: IBusTuyenDuongUpdatePhanTuyenHocSinhRequest): IBusPhanTuyenSavePhanTuyenHocSinhStart => {
		return {
			type: eBusPhanTuyenActionTypeIds.SAVE_PHANTUYEN_HOCSINH_START,
			payload: request
		}
	},
	savePhanTuyenHocSinhSuccess: (): IBusPhanTuyenSavePhanTuyenHocSinhSuccess => {
		return {
			type: eBusPhanTuyenActionTypeIds.SAVE_PHANTUYEN_HOCSINH_SUCCESS
		}
	},
	savePhanTuyenHocSinhError: (message: string): IBusPhanTuyenSavePhanTuyenHocSinhErr => {
		return {
			type: eBusPhanTuyenActionTypeIds.SAVE_PHANTUYEN_HOCSINH_ERROR,
			payload: message
		}
	},
	showDeleteHocSinhConfirm: (data: BusPhanTuyenItemResponse): IBusPhanTuyenShowDeleteHocSinhConfirm => {
		return {
			type: eBusPhanTuyenActionTypeIds.SHOW_DELETE_HOCSINH_CONFIRM,
			payload: data
		}
	},
	closeDeleteHocSinhConfirm: (): IBusPhanTuyenCloseDeleteHocSinhConfirm => {
		return {
			type: eBusPhanTuyenActionTypeIds.CLOSE_DELETE_HOCSINH_CONFIRM
		}
	},
	deleteHocSinhStart: (request: IBusPhanTuyenHuyDangKyRequest): IBusPhanTuyenDeleteHocSinhStart => {
		return {
			type: eBusPhanTuyenActionTypeIds.DELETE_HOCSINH_START,
			payload: request
		}
	},
	deleteHocSinhSuccess: (): IBusPhanTuyenDeleteHocSinhSuccess => {
		return {
			type: eBusPhanTuyenActionTypeIds.DELETE_HOCSINH_SUCCESS
		}
	},
	deleteHocSinhError: (message: string): IBusPhanTuyenDeleteHocSinhErr => {
		return {
			type: eBusPhanTuyenActionTypeIds.DELETE_HOCSINH_ERROR,
			payload: message
		}
	},
	showImportTuyenDuongChiTietModal: (bus_tuyenduong_id: number): IBusPhanTuyenShowImportChiTietModal => {
		return {
			type: eBusPhanTuyenActionTypeIds.SHOW_IMPORT_CHITIET_MODAL,
			payload: bus_tuyenduong_id
		}
	},
	closeImportTuyenDuongChiTietModal: (): IBusPhanTuyenCloseImportChiTietModal => {
		return {
			type: eBusPhanTuyenActionTypeIds.CLOSE_IMPORT_CHITIET_MODAL
		}
	},
	validateImportTuyenDuongChiTietStart: (request: IUploadExcelTuyenDuongChiTietRequest): IBusPhanTuyenValidateImportChiTietStart => {
		return {
			type: eBusPhanTuyenActionTypeIds.VALIDATE_IMPORT_CHITIET_START,
			payload: request
		}
	},
	validateImportTuyenDuongChiTietSuccess: (data: any[]): IBusPhanTuyenValidateImportChiTietSuccess => {
		return {
			type: eBusPhanTuyenActionTypeIds.VALIDATE_IMPORT_CHITIET_SUCCESS,
			payload: data
		}
	},
	validateImportTuyenDuongChiTietError: (message: string): IBusPhanTuyenValidateImportChiTietErr => {
		return {
			type: eBusPhanTuyenActionTypeIds.VALIDATE_IMPORT_CHITIET_ERROR,
			payload: message
		}
	},
	importTuyenDuongChiTietStart: (request: IUploadExcelTuyenDuongChiTietRequest): IBusPhanTuyenImportChiTietStart => {
		return {
			type: eBusPhanTuyenActionTypeIds.IMPORT_CHITIET_START,
			payload: request
		}
	},
	importTuyenDuongChiTietSuccess: (): IBusPhanTuyenImportChiTietSuccess => {
		return {
			type: eBusPhanTuyenActionTypeIds.IMPORT_CHITIET_SUCCESS
		}
	},
	importTuyenDuongChiTietError: (message: string): IBusPhanTuyenImportChiTietErr => {
		return {
			type: eBusPhanTuyenActionTypeIds.IMPORT_CHITIET_ERROR,
			payload: message
		}
	}
}
